import { yupResolver } from "@hookform/resolvers/yup";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  LayoutNodeActionType,
  LayoutNodeInput,
  LayoutNodeType,
} from "@towersystems/roam-common/lib/generated-types";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Spacings } from "react-native-ui-lib";
import { CreateQuickKeyRootParamList } from "../../../../types";
import { useCreateTile } from "../../../../utilities/layout";
import {
  actionNodeInputSchema,
  defaultLayoutNodeInputValues,
  LayoutNodeActionFormVariants,
} from "../../../../utilities/layout/constants";
import { quickKeyColors } from "../../../../utilities/quick-keys";
import {
  Form,
  SaveHeaderFormAware,
  TextButton,
  Page,
} from "@towersystems/roam-common-native";
import { LayoutNodeActionForm } from "../../components";

export type CreateCustomUrlQuickKeyScreenProps = NativeStackScreenProps<
  CreateQuickKeyRootParamList,
  "CreateCustomUrlQuickKeyScreen"
>;

export function CreateCustomUrlQuickKeyScreen({
  navigation,
}: CreateCustomUrlQuickKeyScreenProps) {
  const { config, handleCreateTile } = useCreateTile();

  const methods = useForm<LayoutNodeInput>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultLayoutNodeInputValues,
      action: LayoutNodeActionType.CUSTOM_URL,
      ...config,
      type: LayoutNodeType.ACTION,
      color: quickKeyColors.action.background,
    },
    resolver: yupResolver(actionNodeInputSchema),
  });

  return (
    <Page>
      <FormProvider {...methods}>
        <SaveHeaderFormAware onValidSubmit={handleCreateTile} />
        <Form>
          <LayoutNodeActionForm variant={LayoutNodeActionFormVariants.Create} />
        </Form>
      </FormProvider>
    </Page>
  );
}
